var angular = require('angular');
var $ = require('jquery');
require('cropit')

 angular
  .module("app.directives")
  .directive('cropit', function($timeout){
    return {
      replace: true,
      scope: {
        source: "=",
        size: '@',
        disabled: '=ngDisabled'
      },
      require: 'ngModel',
      template: require('./template.pug'),
      link: function(scope, element, attrs, ngModel){
        element.css('visibility', 'hidden');
        scope.sizeX = scope.size.split(/[xX]/)[0];
        scope.sizeY = scope.size.split(/[xX]/)[1];

        scope.change = function(){
          var el = $(element[0]);
          ngModel.$setViewValue({
            previewSize: el.cropit('previewSize'),
            zoom: el.cropit('zoom'),
            offset: el.cropit('offset')
          })
        }

        scope.$watch('disabled', function(val){
          $(element[0]).cropit(val ? 'disable' : 'reenable');
        })

        scope.$watch('source', function(source){
          if (!source) return;

          $timeout(function(){
            $(element[0]).cropit({
              allowDragNDrop: false,
              imageBackground: true,
              imageState: { src: source },
              width: scope.sizeX,
              height: scope.sizeY,
              smallImage: 'allow',
              onOffsetChange: scope.change,
              onZoomChange: scope.change,
              minZoom: "fit",
            })
            element.css('visibility', '');
          })
        })


      }
    }


  })
